import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { DetalleTransaccion } from 'src/app/model/pld/detalletransacciones.model';
import { Transacciones } from 'src/app/model/pld/transacciones.model';
import { AlertasService } from "src/services/pld/alertas.service";
declare var google;

@Component({
  selector: 'app-addcase-transactions',
  templateUrl: './addcase-transactions.component.html',
  styleUrls: ['./addcase-transactions.component.css']
})
export class AddcaseTransactionsComponent implements OnInit {

  personaResultados: [];
  reporteResultados: any[];
  total: number;
  totalRegistros: number;
  tipoPersonaCombo: number;
  numPage: number;
  contador: number;

  transaccion: DetalleTransaccion = new DetalleTransaccion();
  resultadoPaginadoTotal: [];
  transacciones: Transacciones;
  transaccionesResultados: any[];
  transaccionesRelacionar: any[] = [];
  buscando = false;

  /*Catalogos*/
  personalidadFiscal: [];
  estatus: [];
  sucursales: [];
  areas: [];

  public initLatitude = 20.7046743;
  public initLongitude = -103.3126045;
  @ViewChild('map', { static: true }) mapElement: ElementRef;
  map: any;
  resp: any;
  ver = false;

  constructor(
    public alertaService: AlertasService,
  ) {
    this.transacciones = new Transacciones();
    this.tipoPersonaCombo = 2;
    this.personaResultados = [];
    this.resultadoPaginadoTotal = [];
    this.resp = { coords: { latitude: this.initLatitude, longitude: this.initLongitude } };
  }

  ngOnInit() {
    console.log(this.alertaService.transaccionesRelacionar);
    
    this.transaccionesResultados = [];
    this.transaccionesResultados = this.alertaService.transaccionesRelacionar;
    $("#btntabletransaccion").on("click", function () {
      $('#tabletransaccion').show(); //muestro mediante id
    });
  }

  verDetalle(transaccion: DetalleTransaccion) {
    // for (const transaccion of this.transaccionesResultados) {
    //   if (transaccion['transaccionId'] == transaccionId) {
    // let transaccion = this.transaccionesResultados.find(t=> Number(t.transaccionId) === Number(transaccionId))
    this.transaccion = transaccion as DetalleTransaccion;
    if (this.transaccion && this.transaccion.latitud) {
      this.initMap({ coords: { latitude: this.transaccion.latitud, longitude: this.transaccion.longitud } });
    }
    //   }
    // }
  }

  initMap(resp: any) {
    console.log(resp);

    const markerData: any = [
      { lat: 22.3, lng: 70.8, text: 'Looks Unisex Salon' },
      { lat: 22.3, lng: 70.81, text: 'Beauty Plus Spa' },
      { lat: 22.31, lng: 70.8, text: 'RedBox Barber' },
      { lat: 22.33, lng: 70.81, text: 'Divine Salon' }
    ];

    const latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
    const mapoption = {
      center: latLng,
      zoom: 17,
      streetViewControl: false,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapoption);
    const markerIcon = {
      url: 'assets/images/Map-Marker-Marker-Outside-Azure-icon.png',
      labelOrigin: new google.maps.Point(25, 63),
      scaledSize: new google.maps.Size(56, 64)
    };
    const markerIconCurrent = {
      url: 'assets/images/nevigation-icon.gif',
      scaledSize: new google.maps.Size(35, 35),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 17)
    };
    markerData.forEach((element: any, index) => {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(element.lat, element.lng),
        map: this.map,
        icon: markerIcon,

        label: {
          text: element.text,
          fontSize: '11px',
          fontFamily: 'tofini_medium',
          width: '30px'
        }
      });
    });

    const marker4 = new google.maps.Marker({
      position: latLng,
      map: this.map,
      icon: markerIconCurrent
    });

    const circle = new google.maps.Circle({
      map: this.map,
      radius: 400, // 10 miles in metres
      fillColor: '#007AFF',
      strokeWeight: 0,
      fillOpacity: 0.1
    });
    circle.bindTo('center', marker4, 'position');
  }

  paginador(bool: boolean) {

  }

}
